<template>
    <svg :class="svgClass" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <g id="_1.-Foundations_Icons_ATAS_Icon_FFD" data-name="1.-Foundations/Icons/ATAS_Icon_FFD">
            <path class="cls-1"
                  d="M42.08,22.32l-22-14A2,2,0,0,0,17,10v4L8.08,8.32A2,2,0,0,0,5,10V32a4,4,0,0,0,4-4V13.64l12,7.64V13.64L37.28,24,21,34.36V26.72L5,36.9V38a2,2,0,0,0,3.08,1.68L17,34v4a2,2,0,0,0,3.08,1.68l22-14a2,2,0,0,0,0-3.36Z" />
        </g>
    </svg>
</template>

<script>
export default {
    name: 'fast-forward',
    props: {
        svgClass: {
            type: String,
            default: 'svg-24'
        },
    }
}
</script>
